/**
 * Parse ISO-8601 timestamps using literal calendar date and clock time from the
 * string prefix (ignores offset for placement). Encoded as UTC Date for timeline math.
 */
const WALL_TIME_RE =
  /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?/;

export type IsoWallParts = {
  y: number;
  m: number;
  d: number;
  h: number;
  min: number;
  sec: number;
};

export function parseIsoWallParts(iso: string): IsoWallParts | null {
  const m = iso.trim().match(WALL_TIME_RE);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const h = Number(m[4]);
  const min = Number(m[5]);
  const sec = m[6] != null ? Number(m[6]) : 0;
  if (
    [y, mo, d, h, min, sec].some((n) => Number.isNaN(n)) ||
    mo < 1 ||
    mo > 12 ||
    d < 1 ||
    d > 31
  ) {
    return null;
  }
  return { y, m: mo, d, h, min, sec };
}

export function wallDateFromParts(
  y: number,
  m: number,
  d: number,
  h = 0,
  min = 0,
  sec = 0,
  ms = 0,
): Date {
  return new Date(Date.UTC(y, m - 1, d, h, min, sec, ms));
}

/** Wall-clock instant from API string; falls back to native Date parsing. */
export function wallDateTimeFromIso(iso: string): Date {
  const parts = parseIsoWallParts(iso);
  if (parts) {
    return wallDateFromParts(parts.y, parts.m, parts.d, parts.h, parts.min, parts.sec);
  }
  return new Date(iso.replace(" ", "T"));
}
